import React from 'react';
import { useTranslation } from 'react-i18next';
import { PropTypes } from 'prop-types';
import { Button, ImageWrapper, OnboardingCreatorInfoBlock } from 'components';
import { ReactComponent as Icon } from '../../assets/img/illustrations/onboarding.svg';

const OnboardingWelcomePage = ({ onNext, onLogout }) => {
  const { t } = useTranslation(['pages']);

  return (
    <>
      <h1 className="display-4 text-center">{t('onboarding.title')}</h1>
      <h4 className="text-muted text-center">{t('onboarding.subtitle')}</h4>
      <ImageWrapper big>
        <Icon />
      </ImageWrapper>
      <OnboardingCreatorInfoBlock onLogout={onLogout} />
      <Button className="primary" onClick={onNext}>
        {t('onboarding.buttonText')}
      </Button>
    </>
  );
};

OnboardingWelcomePage.propTypes = {
  onNext: PropTypes.func.isRequired,
  onLogout: PropTypes.func,
};

export default OnboardingWelcomePage;
